module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Light.3383d70.otf";